import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';

import { PlusIcon } from '@/assets/icons/plusIcon';
import { Button } from '@/components/ButtonComponent';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useBalanceModal } from '@/hooks/use-balance-modal';
import { useUserStore } from '@/hooks/use-user-store';
import { useWallet } from '@/hooks/use-wallet';
import { toLocaleCurrency } from '@/utils/numeric/currency';

type BetSlipBalanceButtonProps = {
    testId?: string;
    hasError?: boolean;
};

export const BetSlipBalanceButton = ({ testId }: BetSlipBalanceButtonProps) => {
    const { total } = useWallet();
    const { showBalanceModal } = useBalanceModal();

    const handleBalancePress = useCallback(() => {
        showBalanceModal();
    }, [showBalanceModal]);

    const guest = useUserStore(state => state.guest);
    if (guest) {
        return null;
    }

    const balanceAmountColor = total === 0 ? ds.colorToken.text.danger : ds.colorToken.text.primary;

    return (
        <Box>
            <Button
                onPress={handleBalancePress}
                shape={'pill'}
                style={styles.button}
                label={
                    <Row alignItems="center">
                        <Text variant="titleSmall" color={balanceAmountColor}>
                            {toLocaleCurrency(total)}
                        </Text>
                        <Box
                            width={1}
                            height={12}
                            marginHorizontal={'s12'}
                            backgroundColor={ds.colorToken.background.neutral.strong}
                        />
                        <PlusIcon />
                    </Row>
                }
                testID={testId}
            />
        </Box>
    );
};

const styles = StyleSheet.create({
    button: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        backgroundColor: ds.colorValue.background.neutral.subtler,
        borderRadius: 10,
        borderCurve: 'continuous',
        minWidth: 60,
    },
});
